var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.load)?_c('LineChart',{attrs:{"data":_vm.data,"options":_vm.options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }